const validatePasswords = ({ oldPassword, newPassword, confirmPassword }) => {
  const errors = {};
  if (oldPassword === "") errors.oldPassword = "Field can't be empty!";
  if (newPassword === "") errors.newPassword = "Field can't be empty!";
  if (confirmPassword === "") errors.confirmPassword = "Field can't be empty!";
  if (newPassword && confirmPassword && newPassword !== confirmPassword)
    errors.commonError = "Retyped password does not match!";
  if (oldPassword && newPassword && oldPassword === newPassword)
    errors.commonError = "Old and new Password cannot be same!";
  return errors;
};

function validateURL(str) {
  var pattern = new RegExp(
    "^(https?:\\/\\/)?" + // protocol
      "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
      "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
      "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
      "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
      "(\\#[-a-z\\d_]*)?$",
    "i"
  ); // fragment locator
  return !!pattern.test(str);
}

const validateEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

const validateDetails = ({ personalEmail, linkedin, github, twitter }) => {
  const errors = {};
  if (personalEmail !== "" && !validateEmail(personalEmail))
    errors.personalEmail = "Enter a valid email id!";
  if (linkedin !== "" && !validateURL(linkedin))
    errors.linkedin = "Enter a valid URL!";
  if (github !== "" && !validateURL(github))
    errors.github = "Enter a valid URL!";
  if (twitter !== "" && !validateURL(twitter))
    errors.twitter = "Enter a valid URL!";
  return errors;
};

export { validatePasswords, validateDetails };
